// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import ClicksController from "./clicks_controller"
application.register("clicks", ClicksController)

import IntelligenceChartController from "./intelligence_chart_controller"
application.register("intelligence-chart", IntelligenceChartController)

import MedicineSelectorController from "./medicine_selector_controller"
application.register("medicine-selector", MedicineSelectorController)

import PostalCodeController from "./postal_code_controller"
application.register("postal-code", PostalCodeController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import SearchMapController from "./search_map_controller"
application.register("search-map", SearchMapController)

import SearchTermsSelectorController from "./search_terms_selector_controller"
application.register("search-terms-selector", SearchTermsSelectorController)

import FilterMultiSelectController from "./filter_multi_select_controller"
application.register("filter-multi-select", FilterMultiSelectController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import BlogPostFormController from "./blog_post_form_controller"
application.register("blog-post-form", BlogPostFormController)

import WatchlistAlertController from "./watchlist_alert_controller"
application.register("watchlist-alert", WatchlistAlertController)

import PriceModalController from "./price_modal_controller"
application.register("price-modal", PriceModalController)
